import { formatInvoiceNumber, maskProductName } from "@today/lib"
import { Divider, LoadDetailItem } from "."
import CloseIcon from "../../public/images/close-icon.svg"
import {
  PIISanitizedOrder,
  PIISanitizedLoad,
} from "../../lib/sanitizePIIFields"

type LoadDetailBottomSheetProps = {
  sanitizedLoad: PIISanitizedLoad
  sanitizedOrder: PIISanitizedOrder
  open: boolean
  onDismiss?(): void
}

export function LoadDetailBottomSheet({
  sanitizedLoad,
  sanitizedOrder,
  open,
  onDismiss,
}: LoadDetailBottomSheetProps) {
  const { name, sender, receiver } = sanitizedLoad
  const products = name.split("\n")
  const maskedProductName = maskProductName(products[0])
  const productName =
    products.length === 1
      ? maskedProductName
      : `${maskedProductName} 외 ${products.length - 1}개`

  const displayInvoiceNumber = sanitizedLoad.displayInvoiceNumber

  return (
    <div
      className={`absolute top-0 z-50 h-full w-full overflow-hidden transition-all ${
        open ? "visible" : "invisible"
      }`}
    >
      <div
        className={`absolute h-full w-full cursor-pointer bg-black transition duration-300 ${
          open ? "bg-opacity-80" : "bg-opacity-0"
        }`}
        onClick={onDismiss}
      />
      <div
        className={`absolute bottom-0 w-full break-all rounded-t-2xl bg-white transition duration-300 ${
          open ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <button className="absolute right-6 top-6" onClick={onDismiss}>
          <CloseIcon />
        </button>
        <div className="flex flex-col pb-4 pt-8">
          <div className="flex flex-col px-6">
            <div className="text-gray-3 text-lg">물품 정보</div>
            <div className="mt-2 line-clamp-3 text-2xl font-bold">
              {productName}
            </div>
          </div>
          <div className="bg-gray-0 mt-6 h-2" />
          <LoadDetailItem title="보낸이">
            <div className="flex items-center gap-x-2">
              <span>{sender.name}</span>
            </div>
          </LoadDetailItem>
          <Divider />
          <LoadDetailItem title="받는이">{receiver.name}</LoadDetailItem>
          <Divider />
          <LoadDetailItem title="송장번호">
            {formatInvoiceNumber(displayInvoiceNumber)}
          </LoadDetailItem>
        </div>
      </div>
    </div>
  )
}
